// "Parts bought" on the job sheet (BL-012): the receipts techs and the office recorded for this job,
// waiting or approved, credits beside them so one isn't credited twice; payables approve them here
// as they do beside the bills. The amounts show to who may see cost (Q38) and to payables.

import { AP_PERMS } from '../books/PayablesEntry.tsx';
import { ReceiptCard } from '../books/Receipts.tsx';
import type { JobPurchase } from '../books/receipts-model.ts';
import { Money, useAct, useQuery } from '../books/ui.tsx';
import { holds } from './job-model.ts';
import '../books/books.css';

export function JobPurchases({
  jobId,
  held,
  onChanged,
}: {
  jobId: string;
  held: readonly string[];
  onChanged: (said: string) => Promise<void>;
}) {
  const q = useQuery<{ purchases: JobPurchase[]; approvedCostCents?: number; pendingCostCents?: number }>(
    'jobPurchases.forJob',
    { jobId },
  );
  const act = useAct(
    (said) => void onChanged(said),
    () => q.reload(),
  );
  // none recorded: the section stays out (the sheet asks only for who holds purchases.record, QA-602)
  if (!q.data?.purchases.length) return null;
  const { purchases, approvedCostCents, pendingCostCents } = q.data;
  return (
    <section className="job-sect" aria-labelledby="job-purchases-title">
      <div className="row">
        <h3 id="job-purchases-title">Parts bought</h3>
        {approvedCostCents !== undefined && pendingCostCents !== undefined ? (
          <span className="muted small">
            <Money cents={approvedCostCents} /> approved
            {pendingCostCents ? (
              <>
                {' '}
                · <Money cents={pendingCostCents} /> waiting
              </>
            ) : null}
          </span>
        ) : null}
      </div>
      {/* the books' receipt cards, styled as beside the bills (books.css is scoped to .books) */}
      <div className="books">
        <ul className="cards">
          {purchases.map((p) => (
            <ReceiptCard key={p.id} p={p} act={act} canApprove={holds(held, AP_PERMS)} />
          ))}
        </ul>
      </div>
    </section>
  );
}
